import React from "react";

import { isPortrait } from "../commonMobile";
import nary from "../nary";
import CardTooltip from "../../components/RoadmapCardTooltip";
import { IV2RoadmapClass } from "@/types/V2RoadmapTypes";
import { getBasePcode, getClonePcode } from "../gamePcode";

function addBigRoadDisplay(self, displayAry, tile, type: string) {
	// console.log("aBRD", displayAry);

	//layout
	//BPB
	//BPB
	//BPB
	//BPBB
	//BPPP
	//BBBB
	if (self.currentType === type && self.currentDisplayRow >= 5) {
		self.currentDirection = 0;

		self.currentDisplayCol++;
	} else if (self.currentType !== type || self.currentDisplayRow >= 5) {
		self.currentDirection = 0;

		self.currentDisplayRow = 0;
		self.lastDisplayCol += 1;
		self.currentDisplayCol = self.lastDisplayCol;
	} else {
		if (displayAry[self.currentDisplayRow + 1][self.currentDisplayCol])
			self.currentDirection = 1;
		
		if (self.currentDirection === 1)
			self.currentDisplayCol++;
		else
			self.currentDisplayRow++;
	}
	
	//nudge columns to the left on every overflow
	if (self.currentDisplayCol >= self.totalColumns)
		// console.log("aBRD cDC", self.currentDisplayCol);
		self.firstRoadmapDisplayedCol = self.currentDisplayCol - self.totalColumns + 1;
	
	
	displayAry[self.currentDisplayRow][self.currentDisplayCol] = tile;
	self.bigRoadSequence.push([self.currentDisplayRow, self.currentDisplayCol]);
	
	self.currentType = type;
}

function addDisplayTile(self, displayAry, tile, type) {
	// console.log("aDT", this.currentType, type);
	
	// Goes down:
	// currentDirection = 0
	//
	// Goes right:
	// currentDirection = 1

	if (self.currentType === type && self.currentDisplayRow >= 5) {
		self.currentDirection = 0;

		self.currentDisplayCol++;
	} else if (self.currentType !== type || self.currentDisplayRow >= 5) {
		self.currentDirection = 0;

		self.currentDisplayRow = 0;
		self.lastDisplayCol += 1;
		self.currentDisplayCol = self.lastDisplayCol;
	} else {
		if (displayAry[self.currentDisplayRow + 1][self.currentDisplayCol])
			self.currentDirection = 1;

		if (self.currentDirection === 1)
			self.currentDisplayCol++;
		else
			self.currentDisplayRow++;
	}
	
	displayAry[self.currentDisplayRow][self.currentDisplayCol] = tile;

	//nudge to the left on overflow
	if (self.currentDisplayCol >= self.totalColumns)
		self.firstDisplayedCol = self.currentDisplayCol - self.totalColumns + 1;
	
	self.currentType = type;
}

function addRoadmapType(self, roadmapAry, type) {
	if (self.currentType1 !== type) {
		self.currentCol++;
		self.currentRow = 0;
	} else {
		self.currentRow++;
	}
	
	if (roadmapAry.length <= self.currentRow) {
		roadmapAry.push([]);
		for (let a = 0; a < roadmapAry[0].length; a++)
			roadmapAry[roadmapAry.length - 1][a] = null;
	}
	roadmapAry[self.currentRow][self.currentCol] = type;
	
	self.currentType1 = type;
}

function addTieDisplay(self, tieDisplayAry) {
	self.tieCount++;
	const tieElement = <div key={`tE${self.currentDisplayRow}${self.currentDisplayCol}`} className="sl-baccarat-diagonal-line sl-roadmap-green tie">{ self.tieCount }</div>;
	tieDisplayAry[self.currentDisplayRow][self.currentDisplayCol] = tieElement;
	self.bigRoadSequence.push([self.currentDisplayRow, self.currentDisplayCol]);
}
		
function checkLastIdx(ary, idx) {
	return idx === ary.length - 1;
}

//How to adjust length:
//- Change totalColumns
//- Add/remove cells at the bottom of this file as necessary

//How to adjust gap (example case):
//- subtract totalColumns by 2
//- add 2 extra columns on roadmapColumns in renderV3

//Bug: Big Road mobile landscape inserts item wrongly
//BP
//BP
//B
//B
//B
//BBBBBB

//Expected result:
//PB
//PB
// B
// B
// B
// BBBBBB

function prepareV3Render(mainClass: IV2RoadmapClass) {
	const basePcode = getBasePcode(mainClass.props.pcode);
	// const clonePcode = getClonePcode(basePcode);
	
	// if (mainClass.props.type === "shio")
	// 	console.log("shio props", mainClass.props);
	
	mainClass.firstDisplayedCol = 0;
	mainClass.firstRoadmapDisplayedCol = 0;
	
	// if (mainClass.props.type === "bead-road")
		// console.log("mCpt sLGG", mainClass.props.type, mainClass.props.showLobbyGameGroup);

	//Always count the totalColumns as N - 2
	//  where N is the columns that the user will see
	//  because there will always be 2 empty columns at the rightmost.
	//
	//For example:
	//  When totalColumns is 16, the user will see 18 columns.

	if (mainClass.props.enlarged) //Desktop enlarged
		mainClass.totalColumns = 16;
	else {
		switch (mainClass.props.type) {
			case "big-eye-road":
				mainClass.totalColumns =
					mainClass.props.expanded ? 18 :
					basePcode === "m32" ? 27 :
					50;
			break;
			case "small-road":
			case "cockroach-road":
				mainClass.totalColumns =
					mainClass.props.expanded ? 18 :
					// mainClass.props.small ? (basePcode === "m25" ? 25 : 25) :
					basePcode === "m32" ? 12 : 23; //desktop single
			break;
			case "big-road":
				mainClass.totalColumns =
					mainClass.props.lobbyMobile ? (
						mainClass.props.showLobbyGameGroup && isPortrait() ? 29 :
						isPortrait() ? 13 : 17
					) : //lobby mobile

					mainClass.props.mobile ? (
						isPortrait() ? 14 : //mobile portrait
						(mainClass.props.expanded ? 22 : //mobile landscape V2 expanded
							basePcode === "m32" ? 14 : 4) //mobile landscape
					) : //landscape open/close

					mainClass.props.small ? 14 : //lobby desktop
					basePcode === "m32" ? 17 : 35; //desktop in-game
			break;
			
			case "bead-road":
				mainClass.totalColumns =
					mainClass.props.lobbyMobile ? (
						mainClass.props.showLobbyGameGroup && isPortrait() ? 29 :
						isPortrait() ? 13 : 17
					) : //lobby mobile

					mainClass.props.mobile ? (
						isPortrait() ? 14 : //mobile portrait
						(mainClass.props.expanded ? 18 : 4)
					) : //mobile single game

					mainClass.props.small ? (basePcode === "m25" ? 12 : 14) : //lobby desktop
					(basePcode === "m32" ? 12 : 25); //desktop in-game
			break;

			case "fan":
				mainClass.totalColumns = 
					mainClass.props.lobbyMobile ? (
						isPortrait() ? 7 : 9
					) : // lobby mobile

					mainClass.props.mobile ? (
						isPortrait() ? 14 : //mobile portrait
						(mainClass.props.expanded ? 18 : 4)
					) : //mobile expanded

					mainClass.props.small ? (basePcode === "m25" ? 12 : 14) : //lobby desktop

					25; //desktop in-game
			break;
			
			case "shio":
				mainClass.totalColumns =
					mainClass.props.lobbyMobile ? (
						mainClass.props.showLobbyGameGroup && isPortrait() ? 9 :
						isPortrait() ? 8 : 10
					) : //lobby mobile

					mainClass.props.mobile ? ( //mobile portrait & landscape
						isPortrait() ? 14 : 12
					) :

					mainClass.props.small ? 10 : //desktop multi table

					16; //maximize Desktop
			break;
			
			default:
			break;
		}
	}

	mainClass.bigRoadSequence = [];

	mainClass.roadmapDisplay = [];
	mainClass.roadmapTypes = [];
	mainClass.roadmapTiesDisplay = [];

	// Todo: use clonePcode later
	if (basePcode === "m22" || basePcode === "m28" || basePcode === "m38")
		mainClass.roadmapPairsDisplay = [];
	
	for (let a = 0; a < 9; a++) {
		mainClass.roadmapDisplay[a] = [...Array(9).keys()].map(() => null);
		mainClass.roadmapTypes[a] = [...Array(9).keys()].map(() => null);
		mainClass.roadmapTiesDisplay[a] = [...Array(9).keys()].map(() => null);

		// Todo: use clonePcode later
		if (basePcode === "m22" || basePcode === "m28" || basePcode === "m38")
			mainClass.roadmapPairsDisplay[a] = "1".split("").map(() => []);
	}
	
	// Todo: use clonePcode later
	switch (basePcode) {
		case "m22":
		case "m28":
		case "m38":
			mainClass.simpleBigRoad = getSimpleBaccaratResultArray(mainClass.props.history);
			mainClass.simpleBigRoadPairs = getSimpleBaccaratResultPairArray(mainClass.props.history);
		break;
		
		case "m23":
			mainClass.simpleBigRoad = getSimpleDragonTigerResultArray(mainClass.props.history);
		break;
		
		case "m25":
			mainClass.simpleBigRoad = getSimpleFanTanResultArray(mainClass.props.history);
		break;
		
		case "m27":
			mainClass.simpleBigRoad = getSimpleShioFightResultArray(mainClass.props.history);
		break;

		case "m32":
			mainClass.simpleBigRoad = getSimpleSamGongResultArray(mainClass.props.history);
			// mainClass.simpleBigRoadPairs = getSimpleSamGongResultPairArray(mainClass.props.history);
		break;
		case "m34":
			mainClass.simpleBigRoad = getSimpleHiLoResultArray(mainClass.props.history);
		break;
		case "m40":
			mainClass.simpleBigRoad = getSimpleXocDiaResultArray(mainClass.props.history);
		break;

		default: break;
	}
	
	mainClass.alternatingStyle = (mainClass.props.historyBlink ? "sl-roadmap-alternating" : null);
}

function renderV3(mainClass) {
	// if (!mainClass.totalColumns)
		// console.warn("renderV3 totalColumns is empty");
	
	const roadmapColumns = nary(mainClass.totalColumns + 2);
	const basePcode = getBasePcode(mainClass.props.pcode);

	const { type } = mainClass.props;


	// console.log("rD", mainClass.roadmapDisplay);

	// if (mainClass.props.type === "shio")
	//	console.log("br bPc", basePcode, mainClass.roadmapDisplay);
		
	return (
		<div className={
				"roadmap-table v3" +
				(` ${basePcode} `) +
				(mainClass.props.small ? " small" : "") +
				(mainClass.props.baccaratDarkMode ? " dark" : "") +
				(` ${mainClass.props.type}`)
			}>
			<div className="back-text">
			{
				type === "big-road" ? 
					<span>Big Road</span>
				: type === "bead-road" ?
					<span>Bead Road</span>
				: type === "big-eye-road" ?
					<span>Big Eye Road</span>
				: type === "small-road" ?
					<span>Small Road</span>
				: type === "cockroach-road" ?
					<span>Cockroach Road</span>
				
				//FanTan Special
				: type === "fan" ?
					<span>Fan</span>

				//Shio Fights Special
				: type === "shio" ?
					<span>Bead Road</span>
				: null
			}
			</div>
			
			<div className="roadmap">
			{
				//big eye, small, cockroach roadmaps
				type === "big-eye-road" ||
				type === "small-road" ||
				type === "cockroach-road" ?
					nary(6).map(row => 
						<div className="row" key={row}>
						{
							roadmapColumns.map(col =>
								(
									<div key={col}>
									{
										mainClass.roadmapDisplay[row - 1]
											[col - 1 + mainClass.firstDisplayedCol] ?
										mainClass.roadmapDisplay[row - 1]
											[col - 1 + mainClass.firstDisplayedCol] : null
									}
									</div>
								)
							)
						}
						</div>
				) :
				
				//big & bead roads: 20
				type === "big-road" ? (
					nary(6).map(row => 
						<div className="row" key={"br" + row}>
						{
							roadmapColumns.map(col =>
								(
									<div key={"br_" + row + col}>
									{
										mainClass.roadmapDisplay[row - 1]
											[col - 1 + mainClass.firstRoadmapDisplayedCol] ?

										[
											// Base Circle Element
											mainClass.roadmapDisplay[row - 1]
												[col - 1 + mainClass.firstRoadmapDisplayedCol],

											// Ties
											mainClass.roadmapTiesDisplay[row - 1]
												[col - 1 + mainClass.firstRoadmapDisplayedCol],

											// Pairs
											basePcode === "m22" || basePcode === "m38" ?
												mainClass.roadmapPairsDisplay[row - 1]
												[col - 1 + mainClass.firstRoadmapDisplayedCol] : null
										]
										: null
									}
									</div>
								)
							)
						}
						</div>
					)
				) :

				type === "bead-road" ? (
					nary(6).map((row, rowIdx) => 
						<div className="row" key={row}>
						{
							roadmapColumns.map((col, colIdx) =>
								(
									<div key={col}>
										{
											mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] !== undefined ?
											mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] : null
										}

										{
											mainClass.props.expanded || mainClass.props.small || basePcode === "m34" ?
											null :
											<CardTooltip
												cardset={mainClass.props.history[colIdx * 6 + rowIdx]}
												pcode={mainClass.props.pcode}
												langdata={mainClass.props.langdata}
												/>
										}
									</div>
								)
							)
						}
						</div>
					)
				) :
				
				// FanTan
				type === "fan" ? (
					nary(4).map((row, rowIdx) =>
						<div className="row" key={"ft" + row}>
						{
							roadmapColumns.map((col, colIdx) =>
								(
									<div key={"bt_" + row + col}>
									{
										mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] !== undefined ?
										mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] : null
									}
									</div>
								)
							)
						}
						</div>
					)
				) :
				
				// Shio Fights
				type === "shio" ? (
					nary(4).map((row, rowIdx) =>
						<div className="row" key={"cBR_" + mainClass.props.pcode + "_" + row}>
						{
							roadmapColumns.map((col, colIdx) =>
								(
									<div key={"cBR_" + mainClass.props.pcode + "_" + row + "_" + col}>
										{
											mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] !== undefined ?
											mainClass.roadmapDisplay[rowIdx][colIdx + mainClass.firstDisplayedCol] : null
										}

										{
											mainClass.props.expanded || mainClass.props.small ?
											null :
											<CardTooltip
												cardset={mainClass.props.history[colIdx * 4 + rowIdx]}
												pcode={mainClass.props.pcode}
												langdata={mainClass.props.langdata}
												/>
										}
									</div>
								)
							)
						}
						</div>
					)
				) :
					
				//Predictions
				type === "predictions" ? (
					renderPredictions(mainClass)
				) :
				
				<div>Unknown type: {type}</div>
			}
			</div>
		</div>
	);	
}

function renderPredictions(mainClass) {
	const basePcode = getBasePcode(mainClass.props.pcode);
	const clonePcode = getClonePcode(basePcode);

	// temp disable prediceted for hilo
	// if(clonePcode === "m34") {
	// 	return null
	// }
	
	const blueLetter = clonePcode === "m22" || clonePcode === "m32" || basePcode === "m38" ? "P" :
		clonePcode === "m23" ? "D" :
		clonePcode === "m27" ? "T" : 
		clonePcode === "m34" ? "Hi" : "E";

	const redLetter = clonePcode === "m22" || clonePcode === "m32" || basePcode === "m38" ? "B" :
		clonePcode === "m23" ? "T" :
		clonePcode === "m27" ? "D" :
		clonePcode === "m34" ? "Lo" : "O";

	const bluePredictionArray = clonePcode === "m22" || clonePcode === "m32" || clonePcode === "m38" ? mainClass.playerPrediction :
		clonePcode === "m23" ? mainClass.dragonPrediction :
		clonePcode === "m27" ? mainClass.tianPrediction :
		clonePcode === "m34" ? mainClass.hiPrediction : mainClass.evenPrediction; //FanTan

	const redPredictionArray = clonePcode === "m22" || clonePcode === "m32" || basePcode === "m38" ? mainClass.bankerPrediction :
		clonePcode === "m23" ? mainClass.tigerPrediction :
		clonePcode === "m27" ? mainClass.diPrediction :
		clonePcode === "m34" ? mainClass.loPrediction : mainClass.oddPrediction; //FanTan

	//Template return, no need to change
	return mainClass.props.mobile ? (
		<div>
			<div className="baccarat-prediction-container">
				<div className={
						"baccarat-prediction-letter sl-roadmap-" +
						(clonePcode === "m23" ? "red" : "blue")
					}>
					{ blueLetter }
				</div>
	
				<div className="player-container">
					<div className="circle-hollow">
						{ bluePredictionArray[0] }
					</div>
					
					{ bluePredictionArray[1] }
					{ bluePredictionArray[2] }
				</div>
				
				<br />
	
				<div className={
						"baccarat-prediction-letter sl-roadmap-" +
						(clonePcode === "m23" ? "blue" : "red")
					}>
					{ redLetter }
				</div>
	
				<div className="banker-container">
					<div className="circle-hollow">
						{ redPredictionArray[0] }
					</div>

					{ redPredictionArray[1] }
					{ redPredictionArray[2] }
				</div>
			</div>
		</div>
	) :	(
		<div>
			<div className="baccarat-prediction-container smaller">
				<div key="bpl0"
					className={"baccarat-prediction-letter sl-roadmap-" + (clonePcode === "m23" ? "red" : "blue")}>
					{ blueLetter }
				</div>
				<div key="bpl1"
					className={"baccarat-prediction-letter sl-roadmap-" + (clonePcode === "m23" ? "blue" : "red")}>
					{ redLetter}
				</div>
	
				<br/>
	
				<div className={(clonePcode === "m23" ? "banker" : "player") + "-container"}>
					<div className="circle-hollow">
						{ bluePredictionArray[0] }
					</div>
					
					{ bluePredictionArray[1] }
					{ bluePredictionArray[2] }
				</div>
				
				<div className={(clonePcode === "m23" ? "player" : "banker") + "-container"}>
					<div className="circle-hollow">
						{ redPredictionArray[0] }
					</div>
					
					{ redPredictionArray[1] }
					{ redPredictionArray[2] }
				</div>
			</div>
		</div>
	);
}

function resetAnalysisPointer(self) {
	self.currentCol = -1;
	self.currentRow = 0;
}

function resetDisplayPointer(self) {
	self.currentDisplayRow = 0;
	self.currentDisplayCol = -1;
	self.currentType = "";
	self.currentType1 = "";
	self.lastDisplayCol = -1;
}

function resetTieCount(self) {
	self.tieCount = 0;
}

//Baccarat
function getSimpleBaccaratResultArray(bigRoad) {
	if (!bigRoad)
		return [];
	
	return bigRoad.map(item =>
		item.win === "banker" ? "B" :
		item.win === "player" ? "P" :
		"T"
	);
}

//Baccarat Pair
function getSimpleBaccaratResultPairArray(bigRoad) {
	if (!bigRoad)
		return [];
	
	return bigRoad.map(item =>
		item.bankerPair && item.playerPair ? "D" :
		item.bankerPair ? "B" :
		item.playerPair ? "P" : " ");
}

//Dragon & Tiger
function getSimpleDragonTigerResultArray(bigRoad) {
	//big_road data:
	// { "dragon": "Js", "tiger": "Kd", "value": "tiger", "periode": 42, "gamekey": "2803" }
	
	//scanDragonTiger data:
	//{ "pcode":"m23","dragon":"4h","tiger":"9c","value":"9","win":"tiger","submit":true,"periode":54,"gameSet":2803 }
	
	if (!bigRoad)
		return [];
	
	return bigRoad.map(item =>
		item.win === "dragon" ? "D" :
		item.win === "tiger" ? "T" : "t"
	);
}
//ShioFight
function getSimpleShioFightResultArray(history) {
	if (!history)
		return [];

	return history.map(item =>
		item.win === "di" ? "D" :
		item.win === "tian" ? "T" : "t"
	);
}



//FanTan
function getSimpleFanTanResultArray(history) {
	if (!history)
		return [];

	return history.map(item => item.angka % 2 ? "O" : "E");
}

//SamGong
function getSimpleSamGongResultArray(history) {
	if (!history)
		return [];

	return history.map(item =>
		item.result === "player" ? "P" :
		item.result === "banker" ? "B" : "T"
	);
}

//Hilo
function getSimpleHiLoResultArray(history) {
	if (!history)
		return [];

	return history.map(item =>
		+item.angka > 7 ? "H" :
		+item.angka < 7 ? "L" : "7"
	);
}


export interface IXocDiaHistoryItem {
	"angka": string; // "White,Red,Red,Red",
	"tanggal": string; // "2021-06-15 11:01:17",
	"periode": number; // 7089,
	"hitung": string; // "1",
	"gamekey": number; // 7089,
	"idnomor": number; // 7089
}

function getSimpleXocDiaResultArray(history: IXocDiaHistoryItem[]) {
	if (!history)
		return [];

	return history.map(item => {
		const redCount = (item.angka.match(/Red/g) || []).length;
		return redCount % 2 > 0 ? "O" : "E";
	});
}


export {
	addBigRoadDisplay,
	addDisplayTile,
	addRoadmapType,
	addTieDisplay,
	checkLastIdx,

	getSimpleBaccaratResultArray,
	getSimpleBaccaratResultPairArray,
	getSimpleDragonTigerResultArray,
	getSimpleShioFightResultArray,
	getSimpleFanTanResultArray,
	getSimpleSamGongResultArray,

	getSimpleXocDiaResultArray,

	prepareV3Render,
	renderV3,
	resetAnalysisPointer,
	resetDisplayPointer,
	resetTieCount
};
